import { FormTextField, FormTextFieldProps } from '@razz-team/ui-web';
import { validateIban } from '@razz-team/utils';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiAccountAddressFormat } from '../../openapi';

interface AccountNumberFieldProps extends FormTextFieldProps {
  format: Pick<ApiAccountAddressFormat, 'type' | 'mask'> | undefined;
}

export function AccountNumberField({ format, ...props }: AccountNumberFieldProps) {
  const { t } = useTranslation();

  const label = useMemo(() => {
    if (props.label) return props.label;

    switch (format?.type) {
      case 'IBAN':
        return t('IBAN');
      default:
        return t('Account number');
    }
  }, [format?.type, props.label, t]);

  const validate = useCallback(
    (value: string) => {
      switch (format?.type) {
        case 'IBAN':
          return validateIban(value) ? true : t('Invalid {{label}}', { label });
        default:
          return true;
      }
    },
    [format?.type, label, t],
  );

  return (
    <FormTextField
      autoComplete="off"
      {...props}
      label={label}
      validate={validate}
      placeholder={format?.mask}
    />
  );
}
